import { INPUT_SIZE } from "./types";

export const inputClassNameSize = {
  [INPUT_SIZE.LARGE]: "h-12  gap-x-2  body-md rounded-8 p-2.5",
  [INPUT_SIZE.MEDIUM]: "h-10  rounded-8 body-sm gap-x-2  p-2",
  [INPUT_SIZE.SMALL]: "h-8   gap-x-1 body-xsm rounded-8 p-1.5",
};

export const inputContainerClassNameWithLable = {
  [INPUT_SIZE.LARGE]: "mt-2",
  [INPUT_SIZE.MEDIUM]: "mt-1.5",
  [INPUT_SIZE.SMALL]: "mt-1",
};
export const labelClassName = {
  [INPUT_SIZE.LARGE]: "title-lg ",
  [INPUT_SIZE.MEDIUM]: "title-md-medium ",
  [INPUT_SIZE.SMALL]: "title-sm ",
};

export const inputIconSize = {
  [INPUT_SIZE.LARGE]: "h-6 w-6",
  [INPUT_SIZE.MEDIUM]: "h-5 w-5",
  [INPUT_SIZE.SMALL]: "h-4 w-4",
};

export const hintClassName = {
  [INPUT_SIZE.LARGE]: "body-sm",
  [INPUT_SIZE.MEDIUM]: "body-xsm",
  [INPUT_SIZE.SMALL]: "body-xxsm",
};

export const errorIconClassName = {
  [INPUT_SIZE.LARGE]: "h-5 w-5",
  [INPUT_SIZE.MEDIUM]: "h-4 w-4",
  [INPUT_SIZE.SMALL]: "h-3 w-3",
};

export const errorClassName = {
  [INPUT_SIZE.LARGE]: "mt-2",
  [INPUT_SIZE.MEDIUM]: "mt-1.5",
  [INPUT_SIZE.SMALL]: "mt-1",
};
